import {
    downloadOperatorStatByCompaniesCsv,
    downloadOperatorStatBySalesPointsCsv,
    downloadOperatorTotalStatCsv,
    getOperatorStatsByCompanies,
    getOperatorStatsBySalesPoints,
    getOperatorTotalStats
} from "../helpers/operatorStatService";
import {checkError, closeAlert, receiveErrorAlert} from "./commonsActions";

export const FETCH_OPERATOR_STATS_BY_COMPANIES_BEGIN = 'FETCH_OPERATOR_STATS_BY_COMPANIES_BEGIN';
export const FETCH_OPERATOR_STATS_BY_COMPANIES_SUCCESS = 'FETCH_OPERATOR_STATS_BY_COMPANIES_SUCCESS';
export const FETCH_OPERATOR_STATS_BY_COMPANIES_ERROR = 'FETCH_OPERATOR_STATS_BY_COMPANIES_ERROR';

export const FETCH_OPERATOR_STATS_BY_SALES_POINTS_BEGIN = 'FETCH_OPERATOR_STATS_BY_SALES_POINTS_BEGIN';
export const FETCH_OPERATOR_STATS_BY_SALES_POINTS_SUCCESS = 'FETCH_OPERATOR_STATS_BY_SALES_POINTS_SUCCESS';
export const FETCH_OPERATOR_STATS_BY_SALES_POINTS_ERROR = 'FETCH_OPERATOR_STATS_BY_SALES_POINTS_ERROR';

export const FETCH_OPERATOR_TOTAL_STATS_BEGIN = 'FETCH_OPERATOR_TOTAL_STATS_BEGIN';
export const FETCH_OPERATOR_TOTAL_STATS_SUCCESS = 'FETCH_OPERATOR_TOTAL_STATS_SUCCESS';
export const FETCH_OPERATOR_TOTAL_STATS_ERROR = 'FETCH_OPERATOR_TOTAL_STATS_ERROR';


export const fetchOperatorStatsByCompanies = (query) => dispatch => {
    dispatch({
        type: FETCH_OPERATOR_STATS_BY_COMPANIES_BEGIN
    });
    return getOperatorStatsByCompanies(query).then(res => {
        dispatch({
            type: FETCH_OPERATOR_STATS_BY_COMPANIES_SUCCESS,
            payload: {
                operatorStats: res.data.byCompaniesReportDtos,
                numberOfElements: res.numberOfElements,
                totalElements: res.totalElements,
                totalPages: res.totalPages
            }
        });
        return res
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert('No data')); // error message
        setTimeout(() => {
            dispatch(closeAlert());
            dispatch({
                type: FETCH_OPERATOR_STATS_BY_COMPANIES_ERROR
            })
        }, 2000);

    })
};

export const fetchOperatorStatsBySalesPoints = (query) => dispatch => {
    dispatch({
        type: FETCH_OPERATOR_STATS_BY_SALES_POINTS_BEGIN
    });
    return getOperatorStatsBySalesPoints(query).then(res => {
        dispatch({
            type: FETCH_OPERATOR_STATS_BY_SALES_POINTS_SUCCESS,
            payload: {
                operatorStats: res.data.bySalesPointsReportDtos,
                numberOfElements: res.numberOfElements,
                totalElements: res.totalElements,
                totalPages: res.totalPages
            }
        });
        return res
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert('No data')); // error message
        setTimeout(() => {
            dispatch(closeAlert());
            dispatch({
                type: FETCH_OPERATOR_STATS_BY_SALES_POINTS_ERROR
            })
        }, 2000);

    })
};

export const fetchOperatorTotalStats = (query) => dispatch => {
    dispatch({
        type: FETCH_OPERATOR_TOTAL_STATS_BEGIN
    });
    return getOperatorTotalStats(query).then(res => {
        dispatch({
            type: FETCH_OPERATOR_TOTAL_STATS_SUCCESS,
            payload: {
                operatorStats: res.data.operatorAppInstallDtos,
                numberOfElements: res.numberOfElements,
                totalElements: res.totalElements,
                totalPages: res.totalPages
            }
        });
        return res
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert('No data')); // error message
        setTimeout(() => {
            dispatch(closeAlert());
            dispatch({
                type: FETCH_OPERATOR_TOTAL_STATS_ERROR
            })
        }, 2000);

    })
};

export const fetchOperatorStatByCompaniesCsv = query => dispatch => {
    return downloadOperatorStatByCompaniesCsv(query).then(res => {
        return res;
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};

export const fetchOperatorStatBySalesPointsCsv = query => dispatch => {
    return downloadOperatorStatBySalesPointsCsv(query).then(res => {
        return res;
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};

export const fetchOperatorTotalStatCsv = query => dispatch => {
    return downloadOperatorTotalStatCsv(query).then(res => {
        return res;
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};


// WEBPACK FOOTER //
// ./src/actions/operatorStatsActions.js